// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "._1npeb6eViWhfqQ {\n  display: flex;\n  flex-flow: row wrap;\n  min-height: 26px;\n}\n.B1E5wLLAT-4oVg {\n  line-height: 0;\n  min-height: 0;\n  height: 100%;\n  align-items: center;\n  margin-left: 4px;\n  margin-top: 8px;\n}\n", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"reactionPiles": "_1npeb6eViWhfqQ",
	"empty": "B1E5wLLAT-4oVg"
};
export default ___CSS_LOADER_EXPORT___;
